// Post-payment legal disclaimer — first step after payment confirmation.

import React, { useState } from 'react';
import { getPrivacyPolicyUrl } from '../../../../shared/privacyPolicy';
import {
  ADHOC_DISCLAIMER_CHECKBOX_LABEL,
  ADHOC_DISCLAIMER_LEDE,
  ADHOC_DISCLAIMER_SECTIONS,
  ADHOC_DISCLAIMER_TITLE,
} from '../../content/adhocDisclaimer';
import AdhocFlowLayout from './AdhocFlowLayout';

interface AdhocDisclaimerStageProps {
  onContinue: () => void;
  saving?: boolean;
  error?: string | null;
}

const AdhocDisclaimerStage: React.FC<AdhocDisclaimerStageProps> = ({
  onContinue,
  saving = false,
  error = null,
}) => {
  const checkboxId = 'adhoc-disclaimer-agree';
  const [agreed, setAgreed] = useState(false);

  return (
    <AdhocFlowLayout currentStep={1} stepLabel="Before we begin">
      <div className="flow-legal-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 9v4M12 17h.01M10.29 3.86l-8.18 14.18A2 2 0 0 0 3.82 21h16.36a2 2 0 0 0 1.71-2.96L13.71 3.86a2 2 0 0 0-3.42 0z" />
        </svg>
      </div>

      <h1 className="flow-title-legal">{ADHOC_DISCLAIMER_TITLE}</h1>
      <p className="flow-legal-lede">{ADHOC_DISCLAIMER_LEDE}</p>

      <div className="flow-legal-card">
        {ADHOC_DISCLAIMER_SECTIONS.map((section) => (
          <div key={section.title}>
            <h4>{section.title}</h4>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 40)}>{paragraph}</p>
            ))}
          </div>
        ))}
      </div>

      <div className="flow-consent">
        <input
          id={checkboxId}
          type="checkbox"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        />
        <label htmlFor={checkboxId}>{ADHOC_DISCLAIMER_CHECKBOX_LABEL}</label>
      </div>

      <p className="flow-privacy-note">
        See our{' '}
        <a href={getPrivacyPolicyUrl()} className="privacy-inline-link" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>{' '}
        for how we handle your data.
      </p>

      {error && <p className="flow-error" role="alert">{error}</p>}

      <div className="flow-cta-row">
        <button
          type="button"
          className="flow-primary"
          disabled={!agreed || saving}
          onClick={onContinue}
        >
          {saving ? 'Saving…' : 'Agree & continue'}
        </button>
      </div>
    </AdhocFlowLayout>
  );
};

export default AdhocDisclaimerStage;
